interface AgentDetailMetaProps {
  createdAt: string
  accuracy: number | null
  avgCost: number | null
}

function formatDate(dateStr: string | null): string {
  if (!dateStr) return 'N/A'
  const date = new Date(dateStr)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

function formatAccuracy(accuracy: number | null): string {
  if (accuracy === null) return 'N/A'
  return `${accuracy.toFixed(1)}%`
}

function formatCost(cost: number | null): string {
  if (cost === null) return 'N/A'
  return `$${cost.toFixed(2)}`
}

function AgentDetailMeta({ createdAt, accuracy, avgCost }: AgentDetailMetaProps) {
  return (
    <div className="agent-detail-meta">
      <div className="agent-detail-meta-row">
        <span className="meta-label">Created</span>
        <span data-testid="agent-detail-created" className="meta-value">{formatDate(createdAt)}</span>
      </div>
      <div className="agent-detail-meta-row">
        <span className="meta-label">Accuracy</span>
        <span data-testid="agent-detail-accuracy" className="meta-value">{formatAccuracy(accuracy)}</span>
      </div>
      <div className="agent-detail-meta-row">
        <span className="meta-label">Avg Cost</span>
        <span data-testid="agent-detail-avg-cost" className="meta-value">{formatCost(avgCost)}</span>
      </div>
    </div>
  )
}

export default AgentDetailMeta
